export const incomeByCustomerMapping = (item: any) => ({
  CustomerCompanyName: item.customerCompanyName,
  AllIncome: item.allIncome,
  PaidIncome: item.paidIncome,
});
